import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["__demoMode"],
  _excluded2 = ["id"],
  _excluded3 = ["id"],
  _excluded4 = ["id", "disabled"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import G, { createContext as X, createRef as N, Fragment as H, useContext as $, useEffect as q, useMemo as v, useReducer as z, useRef as K } from "react";
import { useDisposables as j } from '../../hooks/use-disposables.js';
import { useEvent as d } from '../../hooks/use-event.js';
import { useId as O } from '../../hooks/use-id.js';
import { useIsoMorphicEffect as L } from '../../hooks/use-iso-morphic-effect.js';
import { useOutsideClick as Y } from '../../hooks/use-outside-click.js';
import { useOwnerDocument as Z } from '../../hooks/use-owner.js';
import { useResolveButtonType as ee } from '../../hooks/use-resolve-button-type.js';
import { useSyncRefs as h } from '../../hooks/use-sync-refs.js';
import { useTextValue as te } from '../../hooks/use-text-value.js';
import { useTrackedPointer as ne } from '../../hooks/use-tracked-pointer.js';
import { useTreeWalker as re } from '../../hooks/use-tree-walker.js';
import { OpenClosedProvider as oe, State as D, useOpenClosed as ae } from '../../internal/open-closed.js';
import { isDisabledReactIssue7711 as ie } from '../../utils/bugs.js';
import { calculateActiveIndex as se, Focus as y } from '../../utils/calculate-active-index.js';
import { disposables as k } from '../../utils/disposables.js';
import { Focus as Q, FocusableMode as ue, focusFrom as le, isFocusableElement as pe, restoreFocusIfNecessary as W, sortByDomNode as ce } from '../../utils/focus-management.js';
import { match as V } from '../../utils/match.js';
import { Features as J, forwardRefWithAs as F, render as _ } from '../../utils/render.js';
import { Keys as c } from '../keyboard.js';
var me = function (r) {
    return r[r.Open = 0] = "Open", r[r.Closed = 1] = "Closed", r;
  }(me || {}),
  de = function (r) {
    return r[r.Pointer = 0] = "Pointer", r[r.Other = 1] = "Other", r;
  }(de || {}),
  fe = function (a) {
    return a[a.OpenMenu = 0] = "OpenMenu", a[a.CloseMenu = 1] = "CloseMenu", a[a.GoToItem = 2] = "GoToItem", a[a.Search = 3] = "Search", a[a.ClearSearch = 4] = "ClearSearch", a[a.RegisterItem = 5] = "RegisterItem", a[a.UnregisterItem = 6] = "UnregisterItem", a;
  }(fe || {});
function w(e) {
  var u = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (r) {
    return r;
  };
  var r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null,
    s = ce(u(e.items.slice()), function (t) {
      return t.dataRef.current.domRef.current;
    }),
    i = r ? s.indexOf(r) : null;
  return i === -1 && (i = null), {
    items: s,
    activeItemIndex: i
  };
}
var Te = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, 1, function _(e) {
    return e.menuState === 1 ? e : _objectSpread(_objectSpread({}, e), {}, {
      activeItemIndex: null,
      menuState: 1
    });
  }), 0, function _(e) {
    return e.menuState === 0 ? e : _objectSpread(_objectSpread({}, e), {}, {
      __demoMode: !1,
      menuState: 0
    });
  }), 2, function _(e, u) {
    var i;
    var r = w(e),
      s = se(u, {
        resolveItems: function resolveItems() {
          return r.items;
        },
        resolveActiveIndex: function resolveActiveIndex() {
          return r.activeItemIndex;
        },
        resolveId: function resolveId(t) {
          return t.id;
        },
        resolveDisabled: function resolveDisabled(t) {
          return t.dataRef.current.disabled;
        }
      });
    return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
      searchQuery: "",
      activeItemIndex: s,
      activationTrigger: (i = u.trigger) != null ? i : 1
    });
  }), 3, function _(e, u) {
    var s = e.searchQuery !== "" ? 0 : 1,
      i = e.searchQuery + u.value.toLowerCase(),
      o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + s).concat(e.items.slice(0, e.activeItemIndex + s)) : e.items).find(function (l) {
        var m;
        return ((m = l.dataRef.current.textValue) == null ? void 0 : m.startsWith(i)) && !l.dataRef.current.disabled;
      }),
      a = o ? e.items.indexOf(o) : -1;
    return a === -1 || a === e.activeItemIndex ? _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: i
    }) : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: i,
      activeItemIndex: a,
      activationTrigger: 1
    });
  }), 4, function _(e) {
    return e.searchQuery === "" ? e : _objectSpread(_objectSpread({}, e), {}, {
      searchQuery: "",
      searchActiveItemIndex: null
    });
  }), 5, function _(e, u) {
    var r = w(e, function (s) {
      return [].concat(_toConsumableArray(s), [{
        id: u.id,
        dataRef: u.dataRef
      }]);
    });
    return _objectSpread(_objectSpread({}, e), r);
  }), 6, function _(e, u) {
    var r = w(e, function (s) {
      var i = s.findIndex(function (t) {
        return t.id === u.id;
      });
      return i !== -1 && s.splice(i, 1), s;
    });
    return _objectSpread(_objectSpread(_objectSpread({}, e), r), {}, {
      activationTrigger: 1
    });
  }),
  U = X(null);
U.displayName = "MenuContext";
function C(e) {
  var u = $(U);
  if (u === null) {
    var r = new Error("<".concat(e, " /> is missing a parent <Menu /> component."));
    throw Error.captureStackTrace && Error.captureStackTrace(r, C), r;
  }
  return u;
}
function ye(e, u) {
  return V(u.type, Te, e, u);
}
var Ie = H;
function Me(e, u) {
  var _e$__demoMode = e.__demoMode,
    r = _e$__demoMode === void 0 ? !1 : _e$__demoMode,
    s = _objectWithoutProperties(e, _excluded),
    i = z(ye, {
      __demoMode: r,
      menuState: r ? 0 : 1,
      buttonRef: N(),
      itemsRef: N(),
      items: [],
      searchQuery: "",
      activeItemIndex: null,
      activationTrigger: 1
    }),
    _i = _slicedToArray(i, 2),
    _i$ = _i[0],
    t = _i$.menuState,
    o = _i$.itemsRef,
    a = _i$.buttonRef,
    l = _i[1],
    m = h(u);
  Y([a, o], function (g, R) {
    var p;
    l({
      type: 1
    }), pe(R, ue.Loose) || (g.preventDefault(), (p = a.current) == null || p.focus());
  }, t === 0);
  var I = d(function () {
      l({
        type: 1
      });
    }),
    A = v(function () {
      return {
        open: t === 0,
        close: I
      };
    }, [t, I]),
    f = {
      ref: m
    };
  return G.createElement(U.Provider, {
    value: i
  }, G.createElement(oe, {
    value: V(t, _defineProperty(_defineProperty({}, 0, D.Open), 1, D.Closed))
  }, _({
    ourProps: f,
    theirProps: s,
    slot: A,
    defaultTag: Ie,
    name: "Menu"
  })));
}
var ge = "button";
function Re(e, u) {
  var R;
  var r = O(),
    _e$id = e.id,
    s = _e$id === void 0 ? "headlessui-menu-button-".concat(r) : _e$id,
    i = _objectWithoutProperties(e, _excluded2),
    _C = C("Menu.Button"),
    _C2 = _slicedToArray(_C, 2),
    t = _C2[0],
    o = _C2[1],
    a = h(t.buttonRef, u),
    l = j(),
    m = d(function (p) {
      switch (p.key) {
        case c.Space:
        case c.Enter:
        case c.ArrowDown:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(function () {
            return o({
              type: 2,
              focus: y.First
            });
          });
          break;
        case c.ArrowUp:
          p.preventDefault(), p.stopPropagation(), o({
            type: 0
          }), l.nextFrame(function () {
            return o({
              type: 2,
              focus: y.Last
            });
          });
          break;
      }
    }),
    I = d(function (p) {
      switch (p.key) {
        case c.Space:
          p.preventDefault();
          break;
      }
    }),
    A = d(function (p) {
      if (ie(p.currentTarget)) return p.preventDefault();
      e.disabled || (t.menuState === 0 ? (o({
        type: 1
      }), l.nextFrame(function () {
        var M;
        return (M = t.buttonRef.current) == null ? void 0 : M.focus({
          preventScroll: !0
        });
      })) : (p.preventDefault(), o({
        type: 0
      })));
    }),
    f = v(function () {
      return {
        open: t.menuState === 0
      };
    }, [t]),
    g = {
      ref: a,
      id: s,
      type: ee(e, t.buttonRef),
      "aria-haspopup": "menu",
      "aria-controls": (R = t.itemsRef.current) == null ? void 0 : R.id,
      "aria-expanded": t.menuState === 0,
      onKeyDown: m,
      onKeyUp: I,
      onClick: A
    };
  return _({
    ourProps: g,
    theirProps: i,
    slot: f,
    defaultTag: ge,
    name: "Menu.Button"
  });
}
var Ae = "div",
  be = J.RenderStrategy | J.Static;
function Ee(e, u) {
  var M, b;
  var r = O(),
    _e$id2 = e.id,
    s = _e$id2 === void 0 ? "headlessui-menu-items-".concat(r) : _e$id2,
    i = _objectWithoutProperties(e, _excluded3),
    _C3 = C("Menu.Items"),
    _C4 = _slicedToArray(_C3, 2),
    t = _C4[0],
    o = _C4[1],
    a = h(t.itemsRef, u),
    l = Z(t.itemsRef),
    m = j(),
    I = ae(),
    A = function () {
      return I !== null ? (I & D.Open) === D.Open : t.menuState === 0;
    }();
  q(function () {
    var n = t.itemsRef.current;
    n && t.menuState === 0 && n !== (l == null ? void 0 : l.activeElement) && n.focus({
      preventScroll: !0
    });
  }, [t.menuState, t.itemsRef, l]), re({
    container: t.itemsRef.current,
    enabled: t.menuState === 0,
    accept: function accept(n) {
      return n.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : n.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
    },
    walk: function walk(n) {
      n.setAttribute("role", "none");
    }
  });
  var f = d(function (n) {
      var E, x;
      switch (m.dispose(), n.key) {
        case c.Space:
          if (t.searchQuery !== "") return n.preventDefault(), n.stopPropagation(), o({
            type: 3,
            value: n.key
          });
        case c.Enter:
          if (n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), t.activeItemIndex !== null) {
            var S = t.items[t.activeItemIndex].dataRef;
            (x = (E = S.current) == null ? void 0 : E.domRef.current) == null || x.click();
          }
          W(t.buttonRef.current);
          break;
        case c.ArrowDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Next
          });
        case c.ArrowUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Previous
          });
        case c.Home:
        case c.PageUp:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.First
          });
        case c.End:
        case c.PageDown:
          return n.preventDefault(), n.stopPropagation(), o({
            type: 2,
            focus: y.Last
          });
        case c.Escape:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), k().nextFrame(function () {
            var S;
            return (S = t.buttonRef.current) == null ? void 0 : S.focus({
              preventScroll: !0
            });
          });
          break;
        case c.Tab:
          n.preventDefault(), n.stopPropagation(), o({
            type: 1
          }), k().nextFrame(function () {
            le(t.buttonRef.current, n.shiftKey ? Q.Previous : Q.Next);
          });
          break;
        default:
          n.key.length === 1 && (o({
            type: 3,
            value: n.key
          }), m.setTimeout(function () {
            return o({
              type: 4
            });
          }, 350));
          break;
      }
    }),
    g = d(function (n) {
      switch (n.key) {
        case c.Space:
          n.preventDefault();
          break;
      }
    }),
    R = v(function () {
      return {
        open: t.menuState === 0
      };
    }, [t]),
    p = {
      "aria-activedescendant": t.activeItemIndex === null || (M = t.items[t.activeItemIndex]) == null ? void 0 : M.id,
      "aria-labelledby": (b = t.buttonRef.current) == null ? void 0 : b.id,
      id: s,
      onKeyDown: f,
      onKeyUp: g,
      role: "menu",
      tabIndex: 0,
      ref: a
    };
  return _({
    ourProps: p,
    theirProps: i,
    slot: R,
    defaultTag: Ae,
    features: be,
    visible: A,
    name: "Menu.Items"
  });
}
var Se = H;
function xe(e, u) {
  var r = O(),
    _e$id3 = e.id,
    s = _e$id3 === void 0 ? "headlessui-menu-item-".concat(r) : _e$id3,
    _e$disabled = e.disabled,
    i = _e$disabled === void 0 ? !1 : _e$disabled,
    t = _objectWithoutProperties(e, _excluded4),
    _C5 = C("Menu.Item"),
    _C6 = _slicedToArray(_C5, 2),
    o = _C6[0],
    a = _C6[1],
    l = o.activeItemIndex !== null ? o.items[o.activeItemIndex].id === s : !1,
    m = K(null),
    I = h(u, m);
  L(function () {
    if (o.__demoMode || o.menuState !== 0 || !l || o.activationTrigger === 0) return;
    var T = k();
    return T.requestAnimationFrame(function () {
      var P, B;
      (B = (P = m.current) == null ? void 0 : P.scrollIntoView) == null || B.call(P, {
        block: "nearest"
      });
    }), T.dispose;
  }, [o.__demoMode, m, l, o.menuState, o.activationTrigger, o.activeItemIndex]);
  var A = te(m),
    f = K({
      disabled: i,
      domRef: m,
      get textValue() {
        return A();
      }
    });
  L(function () {
    f.current.disabled = i;
  }, [f, i]), L(function () {
    return a({
      type: 5,
      id: s,
      dataRef: f
    }), function () {
      return a({
        type: 6,
        id: s
      });
    };
  }, [f, s]);
  var g = d(function () {
      a({
        type: 1
      });
    }),
    R = d(function (T) {
      if (i) return T.preventDefault();
      a({
        type: 1
      }), W(o.buttonRef.current);
    }),
    p = d(function () {
      if (i) return a({
        type: 2,
        focus: y.Nothing
      });
      a({
        type: 2,
        focus: y.Specific,
        id: s
      });
    }),
    M = ne(),
    b = d(function (T) {
      return M.update(T);
    }),
    n = d(function (T) {
      M.wasMoved(T) && (i || l || a({
        type: 2,
        focus: y.Specific,
        id: s,
        trigger: 0
      }));
    }),
    E = d(function (T) {
      M.wasMoved(T) && (i || l && a({
        type: 2,
        focus: y.Nothing
      }));
    }),
    x = v(function () {
      return {
        active: l,
        disabled: i,
        close: g
      };
    }, [l, i, g]);
  return _({
    ourProps: {
      id: s,
      ref: I,
      role: "menuitem",
      tabIndex: i === !0 ? void 0 : -1,
      "aria-disabled": i === !0 ? !0 : void 0,
      disabled: void 0,
      onClick: R,
      onFocus: p,
      onPointerEnter: b,
      onMouseEnter: b,
      onPointerMove: n,
      onMouseMove: n,
      onPointerLeave: E,
      onMouseLeave: E
    },
    theirProps: t,
    slot: x,
    defaultTag: Se,
    name: "Menu.Item"
  });
}
var Pe = F(Me),
  ve = F(Re),
  he = F(Ee),
  De = F(xe),
  qe = Object.assign(Pe, {
    Button: ve,
    Items: he,
    Item: De
  });
export { qe as Menu };